import { createFileRoute } from '@tanstack/react-router'

import { preloadListUnitsOfMeasure } from '@/api/react-query'

export const Route = createFileRoute('/_authenticated/settings/units-of-measure')({
	loader: async ({ context }) => await preloadListUnitsOfMeasure(context, {}),
	staticData: { crumb: ({ context: { L } }) => L.Settings.UnitsOfMeasure.Title() }
})
